import { render, staticRenderFns } from "./StaffListDescription.vue?vue&type=template&id=7854defc&scoped=true"
import script from "./StaffListDescription.vue?vue&type=script&lang=js"
export * from "./StaffListDescription.vue?vue&type=script&lang=js"
import style0 from "./StaffListDescription.vue?vue&type=style&index=0&id=7854defc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854defc",
  null
  
)

export default component.exports